export function getErrorMessage(error: unknown): string | null {
  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === 'string') {
    return error;
  }

  if (hasMessage(error)) {
    return error.message;
  }

  return null;
}

export function hasStatusCode(error: unknown): error is { statusCode: number } {
  return (
    error != null &&
    typeof error === 'object' &&
    'statusCode' in error &&
    typeof error.statusCode === 'number'
  );
}

export function hasMessage(error: unknown): error is { message: string } {
  return (
    error != null &&
    typeof error === 'object' &&
    'message' in error &&
    typeof error.message === 'string'
  );
}
